// extracted by mini-css-extract-plugin
export var text = "_45-0";